module.exports = __webpack_public_path__ + "img/edit.a1fb257a.svg";